import React, { forwardRef, useEffect, useState } from 'react'
import {Form, Input, Select, Switch} from 'antd'
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';

const AddForm = forwardRef((props,ref) => {
    return (
        <Form
            layout="vertical"
            ref={ref}
        >
          <Form.Item
            name="name"
            label="項目名稱"
            rules={[{required: true,message: '請輸入名稱'}]}
          >
            <Input/>
          </Form.Item>
          <Form.Item
            name="type"
            label="項目類型"
          >
            <Select
              style={{ width: '100%' }}
              showSearch
              placeholder="Select a type"
              optionFilterProp="children"
              options={[
                {
                  value: 1,
                  label: '會議室',
                },
                {
                  value: 2,
                  label: '車輛',
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="enable"
            label="是否啟用"
            valuePropName="checked"
            initialValue={1}
          >
            <Switch checked={true}/>
          </Form.Item>
        </Form>
    )
})
export default AddForm
